<template>
    <div class="contact" :class="stepActive == 1 ? 'bg-gray' : ''">
        <div class="top">
            <div class="title">在线评估</div>
        </div>
        <div class="con">
            <div class="title">
                雇主担保评估表
                <br>
                （SID/482、186、494等）
            </div>
        </div>
        <div class="step">
            <el-steps :active="stepActive" align-center finish-status="success">
                <el-step title="测试题"></el-step>
                <el-step title="个人信息"></el-step>
                <el-step title="提交成功"></el-step>
            </el-steps>
        </div>
        <div v-if="stepActive == 0">
            <div class="form">
                <div class="form-list" v-for="item in questionList">
                    <div class="form-title">{{ item.title }}:</div>
                    <div class="question-lists">
                        <div class="question-list" v-for="question in item.children">
                            <div class="question-title">{{ question.name }}:</div>
                            <el-radio-group v-if="question.type == 'radio'" v-model="question.active">
                                <el-radio v-for="option in question.option" :key="option.name" :label="option.name">
                                    {{ option.name }}
                                </el-radio>
                            </el-radio-group>
                            <el-checkbox-group v-if="question.type == 'checkbox'" v-model="question.active">
                                <el-checkbox v-for="option in question.option" :key="option.name" :label="option.name">
                                    {{ option.name }}
                                </el-checkbox>
                            </el-checkbox-group>
                            <template v-if="question.type == 'input'">
                                <el-input style="width: 400px;" v-model="question.active" placeholder="请填写" />
                            </template>
                            <div class="tip" v-if="question.tip">{{ question.tip }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="btn-con">
                <el-button type="primary" class="btn" @click="submitForm">提交</el-button>
            </div>

        </div>
        <div v-if="stepActive == 1">
            <div class="step1">
                <!-- <p class="score">您的评分：<span>{{ totalScore }}</span>分</p> -->
                <div class="step-1">
                    <div class="input-title"><span>*</span>姓名</div>
                    <el-input placeholder="请输入姓名" v-model="form.name"></el-input>
                    <div class="input-title"><span>*</span>邮箱</div>
                    <el-input placeholder="请输入邮箱" v-model="form.email"></el-input>
                    <div class="input-title">手机号</div>
                    <el-input placeholder="请输入手机号" v-model="form.mobile"></el-input>
                    <div class="input-title">当前所在国家/城市</div>
                    <el-input placeholder="请输入当前所在国家/城市" v-model="form.source"></el-input>
                    <div class="input-title">是否已有澳洲雇主</div>
                    <el-select placeholder="请选择是否已有澳洲雇主" v-model="form.employer">
                        <el-option label="已有" value="已有"></el-option>
                        <el-option label="正在面试" value="正在面试"></el-option>
                        <el-option label="暂无" value="暂无"></el-option>
                    </el-select>
                    <div class="input-title"><span>*</span>微信号</div>
                    <el-input placeholder="请输入微信号" v-model="form.wx_code"></el-input>
                    <div class="input-title">留言</div>
                    <el-input placeholder="请输入留言" v-model="form.about"></el-input>
                    <div class="input-title">附件</div>
                    <el-radio v-model="form.reportType" label="1">上传图片</el-radio>
                    <el-radio v-model="form.reportType" label="2">上传文件</el-radio>
                    <el-upload ref="child1" class="upload-demo"
                        :action="form.reportType == 1 ? host + '/VisApi/uploadImg' : host + '/VisApi/uploadfile'"
                        :on-success="successReport1" :before-remove="removeReport1" :file-list="fileList"
                        :accept="form.reportType == 1 ? '.png, .jpg' : '.rar, .zip, .xls, .xlsx, .doc, .docx'"
                        :before-upload="beforeAvatarUpload1" :on-exceed="onExceedFn1" :limit="1">
                        <el-button type="primary">点击上传</el-button>
                        <template #tip>
                            <div class="el-upload__tip">
                                只能上传 {{ form.reportType == 1 ? 'png、jpg' : "rar、zip、xls、xlsx、doc、docx" }} 文件
                            </div>
                        </template>
                    </el-upload>
                </div>
            </div>
            <div class="btn-con">
                <el-button type="primary" class="btn" @click="backFn(0)">返回上一步</el-button>
                <el-button type="primary" class="btn" @click="subFn">提交</el-button>
            </div>
        </div>
        <div v-if="stepActive == 2">
            <p class="step2">
                谢谢信任！您的信息已经成功提交！ <br>
                我们已收到您的评估信息。将尽快与您联系，提供初步结论和建议。 <br>
                如需加急，请在留言中标注“加急”并说明原因。新传奇签证服务团队很高兴为你服务。 <br>
                我们团队的澳洲、新西兰官方认证的注册移民代理，从业10年来，为超3万客户拿到正向结果。 <br>
                我们在悉尼，工作时间是悉尼时间早九点到晚上五点半，也欢迎添加客服微信，及时沟通。
                <img class="sandywx" src="../../assets/imgs/sandywx.png" alt="">
                <el-button type="primary" class="btn" @click="stepActive = 0">重新测试</el-button>
            </p>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            totalScore: 0,
            stepActive: 2,
            questionList: [
                {
                    "title": "申请人与职业",
                    "children": [
                        {
                            "name": "拟申请类别",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "SID/482（Core Skills）" },
                                { "name": "186（TRT）" },
                                { "name": "186（DE）" },
                                { "name": "494 偏远地区雇主担保" },
                                { "name": "不知道自己应该申请哪类" }
                            ]
                        },
                        {
                            "name": "提名职业（ANZSCO）",
                            "type": "input",
                            "tip": "如不确定，可填写您目前工作岗位名称。",
                            "active": [],
                            "option": []
                        },
                        {
                            "name": "职业评估（如适用）",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "已通过" },
                                { "name": "递交中" },
                                { "name": "未开始" },
                                { "name": "该职业通常不需要（需要评估）" }
                            ]
                        },
                        {
                            "name": "相关工作经验（全职带社保、交税、有劳动合同的）",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "少于 1 年" },
                                { "name": "1-2 年" },
                                { "name": "3-5 年" },
                                { "name": "5-8 年" },
                                { "name": "8 年以上" }
                            ]
                        },
                        {
                            "name": "英语水平（雅思、PTE等均可）",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "无成绩" },
                                { "name": "雅思 4 个 5" },
                                { "name": "雅思 4 个 6" },
                                { "name": "雅思 4 个 7 或以上" },
                                { "name": "其他同等成绩（需要填写）" }
                            ]
                        },
                        {
                            "name": "是否需执照/注册",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "不需要" },
                                { "name": "需要且已具备" },
                                { "name": "需要但尚未具备/待评估" }
                            ]
                        },
                        {
                            "name": "申请人现在澳洲境内还是境外",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "境内" },
                                { "name": "境外" }
                            ]
                        },
                        {
                            "name": "申请人现在持有的澳洲签证状态",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "485 毕业生工签" },
                                { "name": "500 学签" },
                                { "name": "485 副申" },
                                { "name": "407 培训签证" },
                                { "name": "417/462 打工度假签" },
                                { "name": "600 旅游签" },
                                { "name": "482 签证" },
                                { "name": "过桥签" },
                                { "name": "其他类别签证请说明" }
                            ]
                        },
                        {
                            "name": "申请人的国籍",
                            "type": "input",
                            "tip": "",
                            "active": [],
                            "option": []
                        }
                    ]
                },
                {
                    "title": "风险排查",
                    "children": [
                        {
                            "name": "是否有澳洲拒签/签证取消史",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "无" },
                                { "name": "有（需披露并评估）" }
                            ]
                        },
                        {
                            "name": "是否计划携带家属",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "不携带" },
                                { "name": "配偶" },
                                { "name": "子女" },
                                { "name": "配偶+子女" }
                            ]
                        }
                    ]
                }
            ],
            host: "/api",
            form: {
                name: '',
                email: '',
                mobile: '',
                reviewFileUrl: '',
                about: '',
                type_id: 4,
                reportType: '2',
                wx_code: '',
                employer: ''
            },
            file_url: [],
            fileList: [],
            loading: false,
        };
    },
    mounted() {
        this.stepActive = 0
    },
    methods: {
        backFn(index) {
            this.stepActive = index;
            window.scrollTo(0, 0);
        },
        onExceedFn1() {
            this.$message.error("只能上传一个文件");
        },
        successReport1(a, b) {
            console.log(a, '-----1--21-1-1aaa');
            this.file_url = a.data;
            this.fileList.push(a.data);
            this.$message.success("上传成功");
            this.loading = false;
        },
        removeReport1() {
            this.file_url = [];
            this.fileList = [];
        },
        handleRemove1() {
            this.file_url = [];
            this.fileList = [];
        },
        beforeAvatarUpload1(rawFile) { },
        subFn() {
            if (!this.form.name) {
                this.$message.error('请输入姓名')
                return
            }
            if (!this.form.email) {
                this.$message.error('请输入邮箱')
                return
            } 
            if (!this.form.wx_code) {
                this.$message.error('请输入微信号')
                return
            }

            this.$http.review_add4({
                name: this.form.name,
                email: this.form.email,
                mobile: this.form.mobile,
                about: this.form.about,
                type_id: this.form.type_id,
                wx_code: this.form.wx_code,
                employer: this.form.employer,
                reviewtext: JSON.stringify(this.questionList),
                reviewNum: this.score,
                reviewFileUrl: this.file_url
            }).then(res => {
                console.log(res, '------')
                this.$message.success('提交成功')
                this.stepActive = 2;
            })
        },
        submitForm() {
            // 计算总分
            // let totalScore = 0;
            // this.questionList.forEach(questionItem => {
            //     if (!Array.isArray(questionItem.children)) return;
            //     questionItem.children.forEach(child => {
            //         const optionScoreMap = child.option.reduce((map, option) => {
            //             const validScore = Number(option.score) || 0;
            //             map[option.name] = validScore;
            //             return map;
            //         }, {});
            //         switch (child.type) {
            //             case 'radio':
            //                 totalScore += optionScoreMap[child.active] || 0;
            //                 break;
            //             case 'checkbox':
            //                 child.active.forEach(activeName => {
            //                     totalScore += optionScoreMap[activeName] || 0;
            //                 });
            //                 break;
            //             default:
            //                 console.warn(`未处理的题型：${child.type}`, child);
            //                 break;
            //         }
            //     });
            // });
            this.stepActive = 1;
            window.scrollTo(0, 0);
            // this.totalScore = totalScore;
        },
    }
}
</script>

<style lang="less" scoped>
.bg-gray {
    background-color: #f1f1f1;
    padding-bottom: 10px;
}

.upload-demo {
    margin-top: 20px;
    margin-bottom: 40px;
}

.btn-con {
    margin: 0 auto 150px;
    display: flex;
    justify-content: center;
}

.contact {
    .step2 {
        margin: 50px auto 100px;
        font-size: 18px;
        text-align: center;

        .sandywx {
            width: 200px;
            height: 200px;
            display: block;
            margin: 10px auto 0;
        }

        .btn {
            margin: 20px auto 0;
        }
    }

    .step {
        max-width: 700px;
        margin: 30px auto;
    }

    .step1 {
        margin: 0 auto 70px;
        max-width: 600px;
        background-color: #fff;
        padding: 20px 40px;
        border-radius: 10px;

        .score {
            font-size: 20px;

            span {
                margin-right: 6px;
                color: #222222;
                font-size: 30px;
                font-weight: 500;
            }
        }

        .input-title {
            margin-top: 40px;
            color: #333;

            span {
                color: red;
                margin-right: 4px;
            }
        }
    }

    .btn {
        display: block;
    }

    .form {
        max-width: 900px;
        margin: 0 auto;
        margin-bottom: 50px;
        border: 1px solid #ccc;
        background-color: #fff;

        .form-title {
            font-size: 26px;
            font-weight: 500;
            margin: 20px 0;
            text-indent: 20px;
            color: #333;
        }

        .question-lists {
            display: flex;
            flex-wrap: wrap;
        }

        .question-list {
            width: 100%;
            display: inline-block;
            box-sizing: border-box;
            padding: 20px;
            line-height: 30px;
            border-bottom: 1px solid #ccc;
            background-color: #f1f1f1;
        }


        .tip {
            font-size: 14px;
            line-height: 20px;
            color: #222222;
            margin-top: 5px;
        }

        .question-title {
            font-size: 20px;
            margin-bottom: 10px;
        }
    }

    .con {
        max-width: 1200px;
        margin: 50px auto;
        box-sizing: border-box;
    }

    .title {
        font-size: 30px;
        font-weight: 600;
        text-align: center;
        margin: 20px 0;
    }

    .text {
        width: 100%;
        padding: 0 20px;
        box-sizing: border-box;

        p {
            font-size: 16px;
            line-height: 30px;
            margin: 10px 0;
        }

        .border {
            border: 1px solid #ccc;
            padding: 10px;
            margin: 10px 0;
            border-radius: 10px;

            p {
                font-size: 14px;
                line-height: 20px;
                margin: 10px 0;
            }
        }
    }

    .top {
        width: 100vw;
        height: 300px;
        position: relative;
        overflow: hidden;
        background-image: url('../../assets/imgs/concat_us.png');
        background-size: cover;
        transition: .3s all;
        background-position: center;

        .title {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 60px;
            font-weight: 600;
            letter-spacing: 2px;
            color: #222222;
            text-shadow: 3px 3px 5px #fff;
        }



        img {
            width: 100%;
            object-fit: cover;
            height: 100%;
            transition: .3s all;
        }

        &:hover {
            background-size: cover;

            img {
                transform: scale(1.1);
            }
        }
    }

}


@media (max-width: 600px) {
    .contact {
        .top {
            height: 200px;

            .title {
                font-size: 30px;
            }
        }

        .con {
            padding: 0 20px;
        }

        .title {
            font-size: 20px;
        }

        .step {
            zoom: 0.7;
        }

        .step1 {
            padding: 10px 20px;
        }

        .step2 {
            font-size: 18px;
            margin: 100px auto 150px;
        }

        .step2+.btn {
            margin: 0 auto 30px;
        }

        .form {
            padding: 0 15px;
            box-sizing: border-box;

            .question-list {
                padding: 10px;
            }

            .form-title {
                font-size: 20px;
            }

            .question-title {
                font-size: 16px;
            }

            .question-list:nth-child(2n) {
                border-left: none;
            }

            .question-list {}
        }

        .text p {
            font-size: 14px;
        }

        .text {
            padding: 0;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/zh/evaluateMaster.vue